import gql from 'graphql-tag'

export const GET_SEARCH_ITEM = gql`
  {
    searchItem @client
  }
`
